"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelectize = require("react-selectize");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var MultiSelectComp = /*#__PURE__*/function (_React$Component) {
  _inherits(MultiSelectComp, _React$Component);

  function MultiSelectComp(props) {
    var _this;

    _classCallCheck(this, MultiSelectComp);

    _this = _possibleConstructorReturn(this, (MultiSelectComp.__proto__ || Object.getPrototypeOf(MultiSelectComp)).call(this, props));
    var list = props.list || [];
    var value = props.value || [];
    _this.state = {
      selectedOptions: value.map(function (item) {
        return {
          label: item.name,
          value: item.id
        };
      }),
      options: list.map(function (item) {
        return {
          label: item.name,
          value: item.id
        };
      })
    };
    _this.renderValue = _this.renderValue.bind(_assertThisInitialized(_this));
    _this.onRemoveItem = _this.onRemoveItem.bind(_assertThisInitialized(_this));
    _this.onValuesChange = _this.onValuesChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MultiSelectComp, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.value !== this.props.value) {
        this.setState(function (prev) {
          prev.selectedOptions = _this2.props.value.map(function (item) {
            return {
              label: item.name,
              value: item.id
            };
          });
          return prev;
        });
      }

      if (prevProps.list !== this.props.list) {
        this.setState(function (prev) {
          prev.options = _this2.props.list.map(function (item) {
            return {
              label: item.name,
              value: item.id
            };
          });
          return prev;
        });
      }
    }
  }, {
    key: "onValuesChange",
    value: function onValuesChange(values) {
      this.setState({
        selectedOptions: values
      }); // Transform values to an 'event'-like object,
      // so that no change in onChange callback is needed.

      this.props.onChange.call(null, {
        target: {
          name: this.props.name,
          type: 'select-multiple',
          selectedOptions: values.map(function (item) {
            return {
              value: item.value
            };
          })
        }
      });
    }
  }, {
    key: "onRemoveItem",
    value: function onRemoveItem(item) {
      var selectedOptions = this.state.selectedOptions.filter(function (option) {
        return option.value !== item.value;
      });
      this.setState({
        selectedOptions: selectedOptions
      });
      this.props.onChange.call(null, {
        target: {
          name: this.props.name,
          type: 'select-multiple',
          selectedOptions: selectedOptions
        }
      });
    }
  }, {
    key: "renderValue",
    value: function renderValue(item) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "tag-item"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "tag-item__remove",
        onClick: this.onRemoveItem.bind(this, item)
      }), /*#__PURE__*/_react.default.createElement("span", null, item.label));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var hasError = this.props.errors[this.props.name],
          error;

      if (hasError) {
        error = this.props.errors[this.props.name].map(function (errorMsg) {
          return _this3.props.t(errorMsg);
        }).join(', ');
      }

      return /*#__PURE__*/_react.default.createElement("label", {
        className: "input ".concat(hasError ? 'error' : '', " ").concat(this.props.readOnly ? 'read-only' : '')
      }, this.props.label || (0, _utils.capitalizeFirstLetter)(this.props.name), /*#__PURE__*/_react.default.createElement("span", {
        className: "input__wrapper"
      }, /*#__PURE__*/_react.default.createElement(_reactSelectize.MultiSelect, {
        name: this.props.name,
        renderValue: this.renderValue,
        onValuesChange: this.onValuesChange,
        values: this.state.selectedOptions,
        options: this.state.options
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: "input__error"
      }, error));
    }
  }]);

  return MultiSelectComp;
}(_react.default.Component);

MultiSelectComp.defaultProps = {
  value: [],
  errors: {},
  readOnly: false
};
MultiSelectComp.propTypes = {
  t: _propTypes.default.func.isRequired,
  name: _propTypes.default.string.isRequired,
  readOnly: _propTypes.default.bool,
  hasError: _propTypes.default.bool,
  label: _propTypes.default.string.isRequired,
  errors: _propTypes.default.any,
  onChange: _propTypes.default.func,
  list: _propTypes.default.array,
  value: _propTypes.default.array
};
var _default = MultiSelectComp;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-inputs/multiselect.js
// module id = 512
// module chunks = 0